export default __webpack_public_path__ + "static/media/p4.640b15b7.jpg";